// extracted by mini-css-extract-plugin
export default {"root":"nav_root__--OMA"};